import { useNavigate } from "react-router-dom";
import Cover from "../components/BookCover";

export default function CartPage({ cart, setCart }) {
    const navigate = useNavigate();
    const total = cart.reduce((sum, book) => sum + Number(book.price || 0), 0);
    const savings = cart.reduce((sum, book) => sum + Math.max(0, Number(book.orig || 0) - Number(book.price || 0)), 0);
    const fmtINR = (value) => `Rs. ${Number(value || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    const stars = (rating) => "★".repeat(Math.floor(rating || 0)) + "☆".repeat(Math.max(0, 5 - Math.floor(rating || 0)));

    const removeItem = (id) => {
        setCart((current) => current.filter((book) => book._id !== id));
    };

    return (
        <div style={{ minHeight: "100vh", background: "#FDF5F5", padding: "32px 20px" }}>
            <style>{`
                @media (max-width: 900px) {
                    .cart-layout {
                        grid-template-columns: 1fr !important;
                    }
                }
                @media (max-width: 640px) {
                    .cart-item-row {
                        flex-direction: column !important;
                        align-items: flex-start !important;
                    }
                }
            `}</style>
            <div style={{ maxWidth: 1080, margin: "0 auto" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap", marginBottom: 20 }}>
                    <button onClick={() => navigate("/store")} style={{ border: "none", background: "none", color: "#8B1A1A", cursor: "pointer", fontWeight: 700 }}>
                        Back to Store
                    </button>
                    <h1 style={{ margin: 0, color: "#1a0a08" }}>Shopping Cart</h1>
                </div>



                {cart.length === 0 ? (
                    <div style={{ background: "white", border: "1px solid #f0d0c8", borderRadius: 20, padding: 32, textAlign: "center" }}>
                        <h2 style={{ marginTop: 0, color: "#1a0a08" }}>Your cart is empty</h2>
                        <p style={{ color: "#7a5550", marginBottom: 20 }}>Add a book from the store to continue.</p>
                        <button onClick={() => navigate("/store")} style={{ padding: "12px 18px", borderRadius: 10, border: "none", background: "#C0392B", color: "white", fontWeight: 700, cursor: "pointer" }}>
                            Browse Books
                        </button>
                    </div>
                ) : (
                    <div className="cart-layout" style={{ display: "grid", gridTemplateColumns: "minmax(0, 1fr) 320px", gap: 24 }}>
                        <div style={{ display: "grid", gap: 14 }}>
                            {cart.map((book) => (
                                <div key={book._id} className="cart-item-row" style={{ background: "white", border: "1px solid #f0d0c8", borderRadius: 18, padding: 18, display: "flex", gap: 16, alignItems: "center" }}>
                                    <Cover book={book} w={88} h={122} />
                                    <div style={{ flex: 1 }}>
                                        <h3 style={{ marginTop: 0, marginBottom: 6, color: "#1a0a08" }}>{book.title}</h3>
                                        <div style={{ color: "#7a5550", marginBottom: 6 }}>{book.author} · {book.pages} pages</div>
                                        <div style={{ color: "#D4A847", fontSize: 13 }}>{stars(book.rating)} {book.rating}</div>
                                    </div>
                                    <div style={{ textAlign: "right" }}>
                                        <div style={{ fontSize: 22, fontWeight: 800, color: "#C0392B" }}>{fmtINR(book.price)}</div>
                                        <div style={{ fontSize: 12, color: "#c39b9b", textDecoration: "line-through" }}>{fmtINR(book.orig)}</div>
                                        <button onClick={() => removeItem(book._id)} style={{ marginTop: 12, padding: "8px 12px", borderRadius: 8, border: "1px solid #f0d0c8", background: "white", color: "#8B1A1A", fontWeight: 700, cursor: "pointer" }}>
                                            Remove
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div style={{ background: "white", border: "1px solid #f0d0c8", borderRadius: 20, padding: 24, height: "fit-content" }}>
                            <h2 style={{ marginTop: 0, fontSize: 20, color: "#1a0a08" }}>Order Summary</h2>
                            {cart.map((book) => (
                                <div key={book._id} style={{ display: "flex", justifyContent: "space-between", gap: 12, marginBottom: 10, color: "#7a5550" }}>
                                    <span style={{ maxWidth: 180, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{book.title}</span>
                                    <strong style={{ color: "#1a0a08" }}>{fmtINR(book.price)}</strong>
                                </div>
                            ))}
                            <div style={{ borderTop: "1px dashed #f0d0c8", marginTop: 16, paddingTop: 16, display: "grid", gap: 8 }}>
                                <div style={{ display: "flex", justifyContent: "space-between", color: "#7a5550" }}>
                                    <span>Subtotal</span>
                                    <span>{fmtINR(total)}</span>
                                </div>
                                {savings > 0 ? (
                                    <div style={{ display: "flex", justifyContent: "space-between", color: "#1e8449", fontWeight: 700 }}>
                                        <span>You save</span>
                                        <span>-{fmtINR(savings)}</span>
                                    </div>
                                ) : null}
                                <div style={{ display: "flex", justifyContent: "space-between", color: "#1e8449", fontWeight: 700 }}>
                                    <span>Delivery</span>
                                    <span>FREE</span>
                                </div>
                                <div style={{ display: "flex", justifyContent: "space-between", paddingTop: 10, borderTop: "1px solid #f0d0c8", fontWeight: 800, fontSize: 18 }}>
                                    <span>Total</span>
                                    <span style={{ color: "#C0392B" }}>{fmtINR(total)}</span>
                                </div>
                            </div>
                            <button onClick={() => navigate("/checkout")} style={{ marginTop: 18, width: "100%", padding: "14px", borderRadius: 12, border: "none", background: "#C0392B", color: "white", fontWeight: 700, cursor: "pointer" }}>
                                Proceed to Checkout
                            </button>
                            <div style={{ marginTop: 10, color: "#7a5550", fontSize: 12 }}>
                                Coupon entry happens at checkout and is verified on the server.
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
